export default "__VITE_ASSET__CWxTF070__"